module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjgzMzQgNi44MzE3MUg2LjgzMzM1VjExLjgzMTdINS4xNjY2OVY2LjgzMTcxSDAuMTY2Njg3VjUuMTY1MDRINS4xNjY2OVYwLjE2NTAzOUg2LjgzMzM1VjUuMTY1MDRIMTEuODMzNFY2LjgzMTcxWiIgZmlsbD0iIzFBODVFNCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/shortcut-page/add.svg
// module id = 6/CA
// module chunks = 46